import { Component, OnInit } from '@angular/core';
import { HubService } from 'src/services/hub.service';
import { PracticeResourceElement } from 'src/services/hub/practice-resources.interface';
import { DatalayerService } from 'src/services/datalayer.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-practice-resources-panel',
  templateUrl: './practice-resources-panel.component.html',
  styleUrls: ['./practice-resources-panel.component.scss']
})
export class PracticeResourcesPanelComponent implements OnInit {

  resourceList: PracticeResourceElement[] = [];
  
  constructor(
    private hubService: HubService,
    private datalayerService: DatalayerService,
  private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.hubService.fetchPracticeResources(this.translate.currentLang).subscribe(list => {
      this.resourceList = [];
  
      list.forEach(item => {
        if (Array.isArray(item.HubElements)) {
          this.resourceList.push(...item.HubElements);
        } else if (item.HubElements) {
          this.resourceList.push(item.HubElements);
        }
      });
    });
  }

  resourceClick(link: string, text: string, title: string): void {
    const cleanTitle = title.replace(/\\[nt]/g, "").trim();
    this.datalayerService.resourceClick(link, text, cleanTitle);
  }

  onViewMoreClick(event: Event): void {
    event.preventDefault();

    const link = "viewmoreplaceholder";  
    const text = this.translate.instant('Home.viewresources');
    const title = text;

    this.resourceClick(link, text, title);

    window.open(link, "_blank");
  }

}
